import React from "react";
import PropTypes from "prop-types";
import { loadingHints } from "./loadingHints";

const WIDTHS = [480, 800, 1200];
const srcSetFor = (ext) => WIDTHS.map((w) => `/profil-${w}.${ext} ${w}w`).join(", ");

// Largest layout slot is the /about hero column (~38vw at lg+); below lg the
// portrait spans the container (100vw minus the 24px gutters).
const DEFAULT_SIZES = "(min-width: 1024px) 38vw, calc(100vw - 48px)";

/**
 * Chloé's portrait in the fixed 4:5 crop used on the homepage and about page.
 * `priority` marks it as the first-viewport image (eager, high fetch priority).
 *
 * The derivatives (profil-{480,800,1200}.{webp,jpg}) are the centre 4:5 crop of
 * the original square /profil.jpg, converted from Display P3 to sRGB. That crop is
 * exactly what object-fit: cover showed of the square, so the container keeps the
 * same aspect ratio and object-position and nothing moves.
 */
const AuthorPortrait = ({ className = "", priority = false, sizes = DEFAULT_SIZES }) => (
	<div className={`w-full overflow-hidden ${className}`.trim()} style={{ aspectRatio: "4/5" }}>
		<picture className="block w-full h-full">
			<source type="image/webp" srcSet={srcSetFor("webp")} sizes={sizes} />
			<img
				src="/profil-800.jpg"
				srcSet={srcSetFor("jpg")}
				sizes={sizes}
				width={1200}
				height={1500}
				alt="Chloé Lavrat"
				decoding="async"
				{...loadingHints(priority)}
				className="w-full h-full object-cover"
				style={{ objectPosition: "center 20%", filter: "grayscale(0.05)" }}
			/>
		</picture>
	</div>
);

AuthorPortrait.propTypes = {
	className: PropTypes.string,
	/** True when the portrait is in the first viewport (e.g. the /about hero): eager + high fetch priority. */
	priority: PropTypes.bool,
	/** `sizes` attribute for the responsive sources; override when the slot is narrower than the default. */
	sizes: PropTypes.string,
};

export default AuthorPortrait;
